import { useErrorBoundary } from "preact/hooks";
import Bg from "../../assets/bg-error-page.svg";

type ErrorBoundaryProps = {
  error: Error;
};
export const ErrorPage = ({ error }: ErrorBoundaryProps) => {
  const [resetError] = useErrorBoundary();

  const handleErrorReset = () => {
    // resetError();
    window.location.reload();
  };
  return (
    <div
      className="absolute inset-0 z-[1000] h-full w-full bg-white flex items-center justify-between flex-col p-8 overflow-scroll pointer-events-auto"
      style={{
        backgroundImage: `url(${Bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="w-full h-full  flex flex-col justify-end items-center gap-6 ">
        <h1 className="text-[70px] font-bold text-center font-cba-sans-bold">404</h1>
        <h2 className="text-2xl text-center font-cba-sans">Oops, something went wrong!</h2>
        <p className="text-sm text-center">Reason: {error.message}</p>
      </div>
      <div className="w-full h-full flex flex-col justify-center items-center gap-5">
        <button
          className="mx-auto relative max-w-[210px] w-full h-[50px] border text-[#3A3A3A] text-base font-cba-sans-extrabold border-black rounded-full active:opacity-70 "
          onClick={resetError}
        >
          <a
            href="https://forms.gle/Qhr1NxWTa6tA3MQE9"
            target="_blank"
            rel="noreferrer"
          >
            Report Bug
          </a>
        </button>
        <button
          className="mx-auto relative max-w-[210px] w-full h-[50px] border text-[#3A3A3A] text-base font-cba-sans-extrabold border-black rounded-full active:opacity-70 "
          onClick={handleErrorReset}
        >
          Back to Experience{" "}
        </button>
      </div>
    </div>
  );
};
